var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreloader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8224e3",
    d: "M26.43 44.95a45.68 45.68 0 0 0 18.6 36.82h-.3a36.83 36.83 0 1 1 0-73.65h.3a45.68 45.68 0 0 0-18.6 36.83zm44-22.55a45.68 45.68 0 0 0-29.28 29.07l-.1-.28a36.83 36.83 0 0 1 70.05-22.8l.1.3a45.68 45.68 0 0 0-40.77-6.32zm35.27 34.9A45.68 45.68 0 0 0 69 38.45c.1-.06.17-.13.25-.2a36.83 36.83 0 1 1 43.3 59.6c-.08.07-.17.12-.25.18a45.68 45.68 0 0 0-6.6-40.73zm-22.57 44.3a45.68 45.68 0 0 0 6.6-40.72c.08.05.16.1.24.17a36.83 36.83 0 0 1-43.3 59.6l-.24-.2a45.68 45.68 0 0 0 36.7-18.85zm-48.8-7.86a45.68 45.68 0 0 0 40.77-6.3l-.1.28A36.83 36.83 0 1 1 4.96 64.95l.1-.28a45.68 45.68 0 0 0 29.28 29.07z"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 64 64",
    to: "72 64 64",
    dur: "1080ms",
    repeatCount: "indefinite"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreloader);
export default __webpack_public_path__ + "static/media/preloader .13d274c247ac0c01774f844ddad5b63e.svg";
export { ForwardRef as ReactComponent };